/**
 * HUMANSTARSapp
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CalendarEventPriority = {
    Low: 'low',
    Medium: 'medium',
    High: 'high'
} as const;
export type CalendarEventPriority = typeof CalendarEventPriority[keyof typeof CalendarEventPriority];

